import axios from 'axios';
import {backendHost} from '../../config';

export const putStatusPayments = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/finance-operation/status`, params);
};